import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { Meta } from '@angular/platform-browser';
import { ExclusionsListService } from 'src/app/services/exclusions-list.service';
import { ExclusionList } from 'src/app/models/exclusion-list';
import { CommonModule } from '@angular/common';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
    selector: 'app-caip',
    templateUrl: './caip.component.html',
    styleUrls: ['./caip.component.scss'],
    imports:[CommonModule,RouterModule,SafePipe]
})
export class CaipComponent implements OnInit {

  title = "Catholic Affiliate Investment Program";

  // IFC founded in 2009
  yearsInBusiness = new Date().getFullYear() - 2009;

  friendlyUrl = ""

  exclusions: ExclusionList[]

  constructor(public router: Router, public activatedRoute: ActivatedRoute, private seoservice: SeoService, private meta: Meta, private exclusionservice: ExclusionsListService) 
  { 
    this.exclusionservice.getExclusionsList().subscribe(resp => {
   
      //removes first article from header
      this.exclusions = resp;
   
    })
  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'catholic affiliate investment program, catholic affiliate investing services'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Catholic Affiliate Investment Program.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

    this.activatedRoute.params.subscribe(resp => {
      this.friendlyUrl = resp.friendlyUrl?resp.friendlyUrl: "";
// $&(resp.friendlyUrl)
    })

  }

  navigate(path: string) {

    this.router.navigate(["/caip/"+path])

  }

}
